import React from 'react'
import styled from 'styled-components'
import { useRequestFormOptions, useScoutMyRequest, useUser } from 'apis/hooks'
import { Card } from 'components/common/card'
import { ProfileDetail } from 'components/scouts/search/profile-detail'
import {
  ApplicationFulfillment,
  DashboardScoutRequestDetail,
  WithIdLink,
} from 'types/common'
import { initialDashboardScoutRequestDetail } from 'types/initial'

export const ProfilePreview: React.FC<{
  shouldInduceToFill?: boolean
  application?: {
    files?: WithIdLink[]
    links?: WithIdLink[]
    joinReason?: string
    fitReason?: string
    fulfillments?: ApplicationFulfillment
  }
}> = ({ shouldInduceToFill, application }) => {
  const { data: user } = useUser()
  const { data: myProfile } = useScoutMyRequest()
  const { data: option } = useRequestFormOptions()
  if (!user || !myProfile || !option) return null
  const {
    files: applicationFiles,
    links: applicationLinks,
    joinReason,
    fitReason,
    fulfillments,
  } = application || {}
  const request: DashboardScoutRequestDetail = {
    ...initialDashboardScoutRequestDetail,
    ...myProfile,
    image: user.image,
    techStacks: user.interestedTechStacks,
    positions: user.interestedPositionTypes,
    workLevel: myProfile.workLevel
      ? {
          id: myProfile.workLevel,
          name:
            option.workLevels.find((item) => myProfile.workLevel === item.id)
              ?.name || '',
        }
      : null,
    files: [
      ...myProfile.files.map((file) => {
        return { ...file, isAccessible: !!application }
      }),
      ...(applicationFiles?.map((file) => {
        return { ...file, isAccessible: true }
      }) || []),
    ],
    links: [
      ...myProfile.links.map((link) => {
        return { ...link, isAccessible: !!application }
      }),
      ...(applicationLinks?.map((link) => {
        return { ...link, isAccessible: true }
      }) || []),
    ],
    locations: option.locations.filter((item) =>
      myProfile.locations.map((item) => item.id).includes(item.id),
    ),
    serviceAreas: option.serviceAreas.filter((item) =>
      myProfile.serviceAreas.includes(item.id),
    ),
    fundingRounds: option.fundingRounds.filter((item) =>
      myProfile.fundingRounds.includes(item.id),
    ),
    idpCertificates: myProfile.idpCertificates
      .filter((idp) => idp.isCertified)
      .map((idp) => idp.id),
  }
  return (
    <Content>
      <ProfileDetail
        data={{ ...request, joinReason, fitReason, fulfillments }}
        shouldInduceToFill={shouldInduceToFill}
        hasCondition={!application}
      />
    </Content>
  )
}

const Content = styled(Card)`
  padding: 56px 32px;
  @media ${(p) => p.theme.deviceSize.mobile} {
    padding: 48px 16px;
  }
`
